import { RecentlyViewedType, type RecentlyViewedOutput } from "src/http/types";

// The page serializers write RecentlyViewedOutput under its long C# names; the generated type has /secure/rv's short [JsonProperty] names.
// TODO(WEBF-755): read only recentlyViewedType once the RecentlyViewed page DTO replaces RecentlyViewedOutput in this type.
type PageRecentlyViewedOutput = RecentlyViewedOutput & { readonly recentlyViewedType?: RecentlyViewedType };

export const isRecentlyViewedEventOutput = (item: PageRecentlyViewedOutput): boolean =>
  (item.recentlyViewedType ?? item.z) === RecentlyViewedType.Event;

// GenericCategoryCarousel emits category item analytics, so skip this UAE path
// when recently viewed includes event items.
export const getShouldTrackRecentlyViewedCategories = (
  items: readonly PageRecentlyViewedOutput[] | undefined,
): boolean => !!items?.length && items.every((item) => !isRecentlyViewedEventOutput(item));
